import styled, { keyframes } from "styled-components";

const spin = keyframes`
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
`;

export const VerificationContainer = styled.div`
	position: fixed;
	inset: 0;
	z-index: 1100;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 20px 16px;
	background: var(--bt-auth-overlay-bg, rgba(10, 14, 26, 0.94));
	backdrop-filter: blur(12.5px);
`;

export const VerificationModal = styled.div`
	position: relative;
	width: 100%;
	max-width: 800px;
	height: min(80vh, 600px);
	border-radius: 24px;
	border: 1px solid var(--bt-auth-modal-border, #212737);
	background: var(--bt-auth-modal-bg, #171c2a);
	overflow: hidden;
`;

export const LoadingOverlay = styled.div`
	position: absolute;
	inset: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	background: rgba(23, 28, 42, 0.88);
	z-index: 2;
`;

export const LoadingSpinner = styled.div`
	width: 40px;
	height: 40px;
	border: 3px solid var(--bt-auth-tab-border, #2b3245);
	border-top-color: var(--bt-auth-primary, #0362d4);
	border-radius: 50%;
	animation: ${spin} 1s linear infinite;
`;

export const CloseButton = styled.button`
	position: absolute;
	top: 15px;
	right: 15px;
	z-index: 3;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 32px;
	padding: 8px;
	border: none;
	border-radius: 8px;
	background: var(--bt-auth-close-bg, #2b3245);
	color: var(--bt-auth-heading-color, #e5f0fe);
	cursor: pointer;

	svg {
		width: 16px;
		height: 16px;
	}
`;
